<script>
import Swiper from 'swiper'
import {
  reactive, computed, onMounted, watch, ref
} from 'vue'

import searchFactory from '@/compositions/search/SearchFactory'
import searchQueryState from '@/compositions/search/SearchQuery'

export default {
  props: {
    category: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    let slider
    const sliderRef = ref(null)
    const activeCategoriesCount = ref(0)
    const isDefaultView = ref(true)

    const state = reactive({
      isSliderActive: false
    })

    const {
      addCategory,
      removeCategory,
      searchQuery
    } = searchQueryState.searchQueryUse()
    const { termsFacet } = searchFactory.useSearchResult()

    const categoriesFiltered = computed(() => {
      const groups = []

      props.category.categories.forEach((childCategory) => {
        let filteredTerms = []
        if (termsFacet.value) {
          filteredTerms = termsFacet.value.filter((term) => term.term == childCategory.name)
        }
        const newGroup = { ...childCategory }

        if (filteredTerms && filteredTerms.length > 0) {
          newGroup.hasItems = true
          newGroup.itemsCount = filteredTerms[0].count
        } else {
          newGroup.hasItems = false
          newGroup.itemsCount = 0
        }

        newGroup.active = searchQuery.activeCategories
          && searchQuery.activeCategories.length > 0
          && searchQuery.activeCategories.includes(newGroup.name)

        groups.push(newGroup)
      })

      return groups
    })

    function initSlider() {
      const settings = {
        initialSlide: 0,
        grabCursor: true,
        slidesPerView: 'auto',
        spaceBetween: 16
      }

      slider = new Swiper(sliderRef.value, settings)
      state.isSliderActive = true
    }

    function onCategoryExpand() {
      if (slider) {
        slider.destroy()
        slider = null
        state.isSliderActive = false
      } else {
        initSlider()
      }
    }

    function getChildCategoryName(childCategory) {
      const categoryName = childCategory.name.split('_')[1]
      if (childCategory.itemsCount < 1) {
        return categoryName
      }
      return categoryName.concat(' (', childCategory.itemsCount, ') ')
    }

    function onChangeCategory(category) {
      if (!category.active) {
        addCategory(category.name)
      } else {
        removeCategory(category.name)
      }
    }

    onMounted(() => {
      if (!isDefaultView.value) {
        initSlider()
      }
      watch(categoriesFiltered, (categories) => {
        activeCategoriesCount.value = categories.filter((cat) => cat.active).length
        isDefaultView.value = categories.length < 3
      })
    })


    return {
      state,
      categoriesFiltered,
      activeCategoriesCount,
      sliderRef,
      onCategoryExpand,
      onChangeCategory,
      isDefaultView,
      getChildCategoryName
    }
  }
}
</script>

<!--<style>-->
<!--.swiper-slide {-->
<!--  @apply w-auto;-->
<!--}-->
<!--</style>-->
